'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided(code, note) {
  this.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided__f_code = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided__f_note = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided__f_code = code;
  this.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided__f_note = note;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided as $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided };
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided as $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided };
$h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1748828456), true);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided)) {
    var x = this.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided__f_code;
    var x$2 = x$0.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided__f_code;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      return (this.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided__f_note === x$0.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided__f_note);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype.productPrefix__T = (function() {
  return "Provided";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided__f_code;
  }
  if ((n === 1)) {
    return this.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided__f_note;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "code";
  }
  if ((n === 1)) {
    return "note";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided)));
}
export { $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided as $isArrayOf_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided };
var $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided, "app.api.DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided", ({
  Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided: 1,
  Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided as $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Provided };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$-Provided-E-P-S-Code$-Provided.js.map
